import { useQuery } from 'react-query'
import getAllMarketProductCategoriesService, {
  ParamsType,
  QUERY_KEY,
  ResponseType,
} from 'services/market-product-category/get-all-market-product-categories-service'
import { QueryHookType } from 'types/query-hook-type'

type HookType = QueryHookType<ParamsType, ResponseType>
export const useGetAllMarketProductCategories: HookType = (params, options) => {
  const { data, error, isLoading, refetch } = useQuery(
    [QUERY_KEY, params],
    () => getAllMarketProductCategoriesService(params),
    { ...options }
  )
  return { data, error, isLoading, refetch }
}
